class DuiUniqueInstanceManager {
  constructor() {
    this._instancesCollection = {};
  }

  ensureUnique(key, component) {
    this.clearInstance(key);

    this._instancesCollection[key] = component;
  }

  clearInstance(key) {
    const existingInstance = this._instancesCollection[key];
    if (!existingInstance) {
      return;
    }

    existingInstance.$destroy();
    delete this._instancesCollection[key];
  }
}

export default {
  install: function(Vue, options) {
    Vue.duiUniqueInstanceManager = new DuiUniqueInstanceManager();
  },
};
